<template>
  <div class="text-xs-center">
    <v-dialog
    persistent
      v-model="dialog"
      width="500"
    >
      <v-btn style="display:none;"
      color="primary"
      dark
      @click.stop="dialog = true"
      id="open_dialog_btn"
    >
      Open Dialog
    </v-btn>

      <v-card>
        <v-btn icon class="right top" @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        <v-card-title class="headline font-weight-light">
          Server Error
        </v-card-title>
        
        <v-card-text class="grey--primary">
          We couldn't complete your request. The network connection time out.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="close_dialog">
            Retry
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>




<script>
  export default {
    data () {
      return {
        dialog: false
      }
    },
    
    props : ['show_error'],
    
    mounted : function() {
      var link = document.getElementById('open_dialog_btn');
      link.click();
  },
  
  methods : {
    
    close_dialog() {
     
      this.dialog = false;
      
      this.$store.state.server_error_show = false;
      
      this.$router.go(0);
    }
    
    
  }
  
}
</script>